import { createErrorClass } from './createErrorClass';
export const ObjectUnsubscribedError = createErrorClass((_super) => function ObjectUnsubscribedError() {
    _super(this);
    this.message = 'object unsubscribed';
});
//# sourceMappingURL=ObjectUnsubscribedError.js.map